import ROUTE from 'src/utils/routeConstants';

const withVehicle = (route, vehicleId) => `${route}?vehicle=${vehicleId}`;

export const getTyreSetupJourney = ({
  vehicleId,
  tyreManagementEnabled,
  layout,
  isAdmin,
  canEdit,
  justCreated,
  tyreWorkspaceAvailable,
}) => {
  const enabled = Boolean(tyreManagementEnabled);
  const configured = enabled && Boolean(layout);
  const mandatoryPositions = Number(layout?.mandatory_positions) || 0;
  const occupiedPositions = Number(layout?.occupied_positions) || 0;
  const fitted = configured
    && mandatoryPositions > 0
    && occupiedPositions >= mandatoryPositions;

  const steps = [
    { id: 'saved', label: 'Record saved', status: 'complete' },
    {
      id: 'enabled',
      label: 'Tyre tracking on',
      status: enabled ? 'complete' : 'current',
    },
    {
      id: 'configured',
      label: 'Layout configured',
      status: configured ? 'complete' : (enabled ? 'current' : 'pending'),
    },
    {
      id: 'fitted',
      label: 'Tyres fitted',
      status: fitted ? 'complete' : (configured ? 'current' : 'pending'),
    },
  ];

  let title = 'Vehicle record saved';
  let description = 'This vehicle is ready for day-to-day tyre operations.';
  let primaryAction = null;

  if (!enabled) {
    title = 'Turn on tyre tracking';
    description = 'Turn on tyre tracking for this vehicle before choosing its wheel layout.';
    if (canEdit) {
      primaryAction = {
        label: 'Turn on tyre tracking',
        href: `${ROUTE.vehicles}/${vehicleId}/edit#edit-modules`,
      };
    }
  } else if (!configured) {
    title = 'Configure the vehicle layout';
    if (!tyreWorkspaceAvailable) {
      description = 'Tyre layout tools are unavailable in the current application mode.';
    } else {
      description = isAdmin
        ? 'Choose the axle and position layout before fitting tyres.'
        : 'An administrator must configure the axle and position layout before tyres can be fitted.';
    }
    if (isAdmin && tyreWorkspaceAvailable) {
      primaryAction = {
        label: 'Configure layout',
        href: withVehicle(ROUTE.tyreV2Setup, vehicleId),
      };
    }
  } else if (!fitted) {
    title = 'Fit tyres to every required position';
    description = `${occupiedPositions} of ${mandatoryPositions} required positions are fitted.`;
    if (tyreWorkspaceAvailable) {
      primaryAction = {
        label: 'Open tyre workspace',
        href: withVehicle(ROUTE.tyreV2Vehicles, vehicleId),
      };
    }
  } else if (justCreated) {
    if (tyreWorkspaceAvailable) {
      primaryAction = {
        label: 'Open tyre workspace',
        href: withVehicle(ROUTE.tyreV2Vehicles, vehicleId),
      };
    }
  }

  return {
    steps,
    title,
    description,
    primaryAction,
    secondaryAction: justCreated ? { label: 'Back to vehicles', href: ROUTE.vehicles } : null,
    complete: fitted,
    visible: Boolean(justCreated) || !fitted,
  };
};
